// extracted by mini-css-extract-plugin
module.exports = {"data_container":"style_data_container__3fTgv"};